import { refKey, type IconType } from "@/helpers/iconManifest";
import { iconsIndexDB } from "@/persistentStorage/iconsIndexDB";
import { iconsContentDB } from "@/persistentStorage/iconsContentDB";

// refKey -> path. Uma única leitura do registo __refs__ por sessão.
let refs: Record<string, string> | null = null;
let refsLoading: Promise<Record<string, string>> | null = null;

// path -> data URI já lido do IndexedDB.
const contentCache = new Map<string, string>();
// path -> leitura em curso, para não duplicar o mesmo ícone.
const inFlight = new Map<string, Promise<string | undefined>>();

async function loadRefs(): Promise<Record<string, string>> {
  if (refs) return refs;
  if (!refsLoading) {
    refsLoading = iconsIndexDB
      .getRefs()
      .then((r) => (refs = r ?? {}))
      .catch((e) => {
        console.error("[ICONS] falha ao ler __refs__", e);
        return (refs = {});
      })
      .finally(() => {
        refsLoading = null;
      });
  }
  return refsLoading;
}

/** Invalidar depois de um commit do sincronizador. */
export function invalidateIconRefs(): void {
  refs = null;
  contentCache.clear();
}

async function readContent(path: string): Promise<string | undefined> {
  const hit = contentCache.get(path);
  if (hit) return hit;

  const pending = inFlight.get(path);
  if (pending) return pending;

  const p = iconsContentDB
    .get(path)
    .then((value) => {
      if (typeof value !== "string" || value.length === 0) return undefined;
      contentCache.set(path, value);
      return value;
    })
    .catch((e) => {
      console.error("[ICONS] falha ao ler conteúdo", path, e);
      return undefined;
    })
    .finally(() => {
      inFlight.delete(path);
    });

  inFlight.set(path, p);
  return p;
}

export async function getIconByRef(
  screen: string,
  type: IconType,
  key: string,
): Promise<string | undefined> {
  const map = await loadRefs();
  const path = map[refKey(screen, type, key)];
  if (!path) return undefined;
  return readContent(path);
}
